module.exports = __webpack_public_path__ + "media/images/icons/outlined/gateway-d1f5b1231323084c636c693658560341.svg";